import { useEffect, useState } from "react";

type Props = {
	isReady?: boolean;
};

const useGetTimer = ({ isReady }: Props) => {
	const totalTime = 4 * 60 + 30;
	const [timeLeft, setTimeLeft] = useState<number>(totalTime);

	useEffect(() => {
		if (isReady) {
			const intervalId = setInterval(() => {
				setTimeLeft((prev) => {
					if (prev <= 1) {
						clearInterval(intervalId);
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
			return () => clearInterval(intervalId);
		}
	}, [isReady]);

	return { timeLeft };
};

export default useGetTimer;
